module.exports = __webpack_public_path__ + "static/media/Museo-Thyssen-Bornemisza.bc8900ca.jpg";